import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import {
    FaMapMarkerAlt, FaBirthdayCake, FaRulerVertical,
    FaWeight, FaMoneyBillWave, FaBriefcase,
    FaStar, FaClock, FaArrowLeft, FaTimes, FaChevronLeft, FaChevronRight, FaPhone
} from "react-icons/fa";
import { Modal } from "react-bootstrap";
import "animate.css";
import { baseUrl } from "../App";

function UserFullProfile() {

    const { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState({});
    const [gallery, setGallery] = useState([]);
    const [showGalleryModal, setShowGalleryModal] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        fetchUser();
        fetchGallery();
    }, []);

    const fetchUser = async () => {
        try {
            const res = await axios.get(`${baseUrl}/get/${id}`);
            setUser(res.data);
            console.log("UserFullProfile : ",res.data)
        } catch (error) {
            console.error(error);
        }
    };

    const fetchGallery = async () => {
        try {
            const res = await axios.get(`${baseUrl}/user/${id}`);
            if (Array.isArray(res.data)) {
                setGallery(res.data);
            } else {
                setGallery([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setShowGalleryModal(true);
    };

    const handleNext = () => {
        setCurrentImageIndex((prev) => (prev + 1) % gallery.length);
    };

    const handlePrev = () => {
        setCurrentImageIndex((prev) => (prev - 1 + gallery.length) % gallery.length);
    };

    return (
        <div className="container mt-4 animate__animated animate__fadeIn">

            {/* 🔙 Back Button */}
            <button
                className="btn btn-outline-primary mb-3"
                onClick={() => navigate(-1)}
            >
                <FaArrowLeft className="me-2" />
                Back
            </button>

            <div className="card shadow-lg border-0 p-4">

                <div className="row">

                    {/* Profile Image */}
                    <div className="col-md-4 text-center mb-3">
                        <img
                            src={`https://lingayatwelfarekarnataka.com/${user.profile_photo_path}`}
                            alt="Profile"
                            className="img-fluid rounded shadow"
                            style={{
                                maxHeight: "350px",
                                objectFit: "cover",
                                borderRadius: "15px"
                            }}
                        />
                    </div>

                    {/* Basic Info */}
                    <div className="col-md-8">

                        <h3 className="fw-bold">{user.name}</h3>
                        <p className="text-muted">
                            {user.age} Years • {user.gender}
                        </p>

                        <hr />

                        <div className="row">
                            <div className="col-md-6">
                                <p>
                                    <FaMapMarkerAlt className="me-2 text-danger" />
                                    {user.city}, {user.address}
                                </p>
                            </div>

                            <div className="col-md-6">
                                <p>
                                    <FaPhone className="me-2 text-success" />
                                    {user.mobile}
                                </p>
                            </div>

                            <div className="col-md-6">
                                <p>
                                    <FaBirthdayCake className="me-2 text-warning" />
                                    {user.dateOfBirth}
                                </p>
                            </div>

                            <div className="col-md-6">
                                <p>
                                    <FaRulerVertical className="me-2 text-info" />
                                    {user.height} cm
                                </p>
                            </div>

                            <div className="col-md-6">
                                <p>
                                    <FaWeight className="me-2 text-secondary" />
                                    {user.weight} kg
                                </p>
                            </div>

                            <div className="col-md-6">
                                <p>
                                    <FaMoneyBillWave className="me-2 text-success" />
                                    {user.annual_income}
                                </p>
                            </div>

                            <div className="col-md-6">
                                <p>
                                    <FaBriefcase className="me-2 text-primary" />
                                    {user.work_location}
                                </p>
                            </div>

                            {user.qualification && (
                                <div className="col-md-6">
                                    <p>
                                        <FaBriefcase className="me-2 text-success" />
                                        {user.qualification}
                                    </p>
                                </div>
                            )}
                        </div>

                    </div>

                </div>

                <hr />

                {/* About Section */}
                <h5 className="fw-bold mt-3">About</h5>
                <p>{user.about_me}</p>

                <hr />

                {/* Horoscope Section */}
                <h5 className="fw-bold mt-3">Horoscope Details</h5>

                <div className="row">

                    <div className="col-md-4">
                        <p>
                            <FaMapMarkerAlt className="me-2 text-danger" />
                            Birth Place: {user.birth_place}
                        </p>
                    </div>

                    <div className="col-md-4">
                        <p>
                            <FaClock className="me-2 text-secondary" />
                            Birth Time: {user.birth_time}
                        </p>
                    </div>

                    <div className="col-md-4">
                        <p>
                            <FaStar className="me-2 text-warning" />
                            Raasi: {user.raasi}
                        </p>
                    </div>

                    <div className="col-md-4">
                        <p>
                            <FaStar className="me-2 text-warning" />
                            Star: {user.star}
                        </p>
                    </div>

                </div>

            </div>

            {/* Gallery Section */}
            {gallery.length > 0 && (
                <div className="card shadow-lg border-0 p-4 mt-4">
                    <h5 className="fw-bold mb-3">Gallery</h5>
                    <div className="row">
                        {gallery.map((photo, index) => (
                            <div key={photo.id} className="col-6 col-md-3 mb-3">
                                <div style={{ height: "150px", width: "100%", overflow: "hidden", borderRadius: "8px" }}>
                                    <img
                                        src={`https://lingayatwelfarekarnataka.com/${photo.photo_path}`}
                                        alt="Gallery"
                                        className="rounded shadow"
                                        style={{
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "cover",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => handleImageClick(index)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Gallery Modal with Swiper */}
            <Modal
                show={showGalleryModal}
                onHide={() => setShowGalleryModal(false)}
                centered
                size="lg"
            >
                <Modal.Body className="text-center position-relative p-0">
                    <FaTimes
                        size={28}
                        color="#dc3545"
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "15px",
                            cursor: "pointer",
                            zIndex: 10,
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50%",
                            padding: "5px"
                        }}
                        onClick={() => setShowGalleryModal(false)}
                    />

                    <FaChevronLeft
                        size={40}
                        color="#0d6efd"
                        style={{
                            position: "absolute",
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: 10,
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50%",
                            padding: "8px"
                        }}
                        onClick={handlePrev}
                    />

                    <FaChevronRight
                        size={40}
                        color="#0d6efd"
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: 10,
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50%",
                            padding: "8px"
                        }}
                        onClick={handleNext}
                    />

                    <img
                        src={`https://lingayatwelfarekarnataka.com/${gallery[currentImageIndex]?.photo_path}`}
                        alt="Gallery"
                        className="img-fluid"
                        style={{ maxHeight: "80vh", width: "100%", objectFit: "contain" }}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default UserFullProfile;
